export enum MarketplaceSource {
  AMAZON = 'Amazon',
}
